module.exports = __webpack_public_path__ + "static/img/pc-web-img-02@m.b11c3b4.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/lgchem/pc-web-img-02@m.png
// module id = J/dS
// module chunks = 0